export const EDIT_SUCCESS = 'Коннектор обновлен';
export const EDIT_ERROR = 'Не удалось обновить коннектор';
